































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { State, Action, namespace } from 'vuex-class'
import addDecor2El, { selectSVG, resizeSvg } from './unlockdecor'
import { Power1, TweenLite, gsap } from 'gsap'
import { activationDayPlan, saveMyDayPlan } from '@/api/plan/myDayPlan'
import { getShareCard } from '@/api/plan/shareCard'
import ShareCard from '@/model/plan/shareCard'
import { emojiList } from '@/api/plan/mood'
import MyDayPlan from '@/model/plan/myDayPlan'
import moment from 'moment'
import num2Chinese from '@/apps/ice/utils/chinese_num'
import Mood from '@/model/plan/mood'

const ModuleStudyPlan = namespace('app-ice/studyPlan')

@Component
export default class StudyPlanUnlock extends Vue {
  emojiList: Array<any> = emojiList
  courseList: Array<any> = []
  isHiddenSelector: boolean = false
  card: any = {}
  myDayPlanList: Array<MyDayPlan> = []
  num2Chinese: any = num2Chinese
  showMask: boolean = false

  @ModuleStudyPlan.Action('fetchMood')
  private fetchMood!: Function
  @ModuleStudyPlan.State((state) => state.mood)
  mood?: Mood

  async mounted() {
    const isSuccess = await this.activation()
    if (!isSuccess) {
      setTimeout(() => {
        this.$router.push('/personal/studyplan/invalid')
      }, 500)
    }
    this.$nextTick(() => {
      selectSVG('svg')
      resizeSvg({ svgSize: { width: 0, height: 0 } })
    })
  }

  async activation() {
    const shareCardId: string = this.$route.params.id
    const card: ShareCard = await getShareCard(shareCardId)
    // 没查到卡
    if (!card || JSON.stringify(card) === '{}') {
      this.somethingWrong()
      return true
    }
    // 未失效
    if (!card.singlePersonal || !card.receiveAccountId) {
      const result: MyDayPlan[] = await activationDayPlan({ shareCardId })
      if (result && result.length > 0) {
        this.myDayPlanList = result
      }
      if (result && result.length === 0) {
        this.$message.warning('已经解锁过该任务了～')
        return false
      }
      if (card.dayPlan && card.dayPlan.dayPlanOutlines) {
        card.dayPlan.dayPlanOutlines.forEach((p: any) => {
          p.planOutlines.forEach((o: any) => this.courseList.push(o))
        })
      }
      this.card = card
      return !!result
    }
    return false
  }

  /**
   * 心情选择 selector 和 解锁界面 的切换
   */
  toggleSelector(emojiType: any) {
    const timer = setTimeout(() => {
      this.isHiddenSelector = !this.isHiddenSelector
      if (this.isHiddenSelector) {
        typeof emojiType === 'string' && this.saveMood(emojiType)
        this.singleLetters()
        this.animateCourseName()
      } else {
        this.reverse()
      }
      clearTimeout(timer)
    }, 500)
  }

  reverse() {
    const textEls = document.querySelectorAll('.course-item .text')
    this.courseList.forEach((course: any, index: number) => {
      const text = course.name
      const textEl = textEls[index]
      textEl.innerHTML = text
    })
  }

  /**
   * 保存用户选择的“心情”
   */
  async saveMood(emojiType: string) {
    if (emojiType && this.myDayPlanList.length > 0 && this.card.id) {
      let myDayPlan = this.myDayPlanList.find(
        (myDayPlan: MyDayPlan) => myDayPlan.dayPLanId === this.card.planDayId
      )

      if (!myDayPlan) {
        // const lastestPlan = this.myDayPlanList.sort(
        //   (current: MyDayPlan, next: MyDayPlan) => {
        //     return moment(current.dayPlan.planDay).isAfter(next.dayPlan.planDay)
        //       ? -1
        //       : 1
        //   }
        // )
        // myDayPlan = lastestPlan[0]
        this.somethingWrong()
        return
      }

      if (myDayPlan) {
        const result = await saveMyDayPlan({
          moodDescription: emojiType,
          id: myDayPlan.id,
        })
        result && (await this.fetchMood(myDayPlan.id))
      }
    }
  }

  somethingWrong() {
    this.showMask = true
  }

  singleLetters() {
    const textEls = document.querySelectorAll('.course-item .text')
    this.courseList.forEach((course: any, index: number) => {
      const text = course.name
      var letters = text.split('')
      for (let i in letters) {
        letters[i] = '<span class="letter">' + letters[i] + '</span>'
      }
      var newLetters = letters.join('')
      const textEl = textEls[index]
      textEl.innerHTML = newLetters
    })
  }

  animateCourseName() {
    var duration = 1000
    var typeLettersDelay = 50
    const courseEls = document.querySelectorAll('.course-item')
    Array.from(courseEls).forEach((courseEl: any, index: number) => {
      setTimeout(() => {
        courseEl.querySelector('.book').classList.add('in')
        //@ts-ignore
        this.showLetter(
          courseEl.querySelector('.text').children[0],
          typeLettersDelay,
          courseEl,
          index === courseEls.length - 1
        )
      }, duration * index + 1000)
    })
  }

  showLetter(
    $letter: HTMLElement,
    $duration: number,
    courseEl: HTMLElement,
    addDecor: boolean = false
  ) {
    $letter.classList.add('in')
    let timer

    if ($letter.nextElementSibling) {
      // debugger
      setTimeout(() => {
        this.showLetter(
          //@ts-ignore
          $letter.nextElementSibling,
          $duration,
          courseEl,
          addDecor
        )
      }, $duration)
    } else {
      // 出现check
      const checkIcon = courseEl.querySelector('.check')
      checkIcon && checkIcon.classList.add('in')

      if (addDecor) {
        addDecor2El({
          decorSize: 140,
          decorPos: { y: 254 },
          svgSize: { width: window.innerWidth, height: window.innerHeight },
          selector: '.study-plan_unlock',
          duration: 0.8,
          onComplete: this.scaleTitle,
        })
      }
    }
  }

  scaleTitle() {
    let tl = gsap.timeline()
    tl.fromTo(
      '.title-img.shadow',
      0.6,
      { opacity: 1 },
      {
        scale: 2,
        y: 100,
        ease: Power1.easeInOut,
        onComplete: () => {
          resizeSvg({ svgSize: { width: 0, height: 0 } })
        },
      }
    ).to('.title-img.shadow', 0.3, { opacity: 0, ease: Power1.easeInOut })
  }

  get avatar() {
    let avatar =
      '//style.youkeda.com/img/ice/default_icon.png?x-oss-process=image/resize,m_mfit,h_150,w_150'
    if (this.mood && this.mood.account) {
      const account = this.mood.account
      if (account && account.user && account.user.avatarUrl) {
        avatar = account.user.avatarUrl
        if (
          (!avatar && avatar.indexOf('oss-cn-hangzhou.aliyuncs.com') !== -1) ||
          avatar.indexOf('youkeda.com') !== -1
        ) {
          avatar = `${avatar}?x-oss-process=image/resize,m_mfit,h_150,w_150`
        }
      }
    }
    return avatar
  }
}
